import { App, Button, Modal, notification, Space, Switch, Table } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { deleteTag, getTagList, updateTag } from '../../../common/request'
import ResponseCode from '../../../common/response-code'
import CreateTagItemModal from './CreateTagItemModal'

function ConfigTagManagement ({orgItem, modalVisible}) {
  const createTagModalRef = useRef()
  const { modal } = App.useApp()
  const [pageNum, setPageNum] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(false)

  const columns = [
    {
      title: '标签名',
      dataIndex: 'name'
    },
    {
      width: 400,
      title: '标签颜色',
      dataIndex: 'color',
      render: (color) => {
        return (
          <div
            style={ {
              backgroundColor: color,
              width: '20px',
              height: '20px',
              borderRadius: '4px'
            } }
          ></div>
        )
      }
    },
    {
      title: '状态',
      dataIndex: 'status',
      render: (status, record) => {
        return (
          <div>
            <Switch checked={ !!status } onChange={ () => handleChangeTagStatus(record) }></Switch>
          </div>
        )
      }
    },
    {
      width: 120,
      title: '操作',
      dataIndex: 'action',
      render: (_, record) => {
        return (
          <Space>
            <Button
              size="small"
              ghost
              type={ 'primary' }
              onClick={ showCreateTagModal.bind(this, 'edit', record) }
            >
              编辑
            </Button>
            <Button
              ghost
              danger
              size="small"
              type={ 'primary' }
              onClick={ () => deleteTagAction(record) }
            >
              删除
            </Button>
          </Space>
        )
      }
    }
  ]

  const deleteTagAction = (record) => {
    modal.confirm({
      title: '删除标签',
      content: '确定要删除该标签吗？',
      centered: true,
      onOk: () => {
        deleteTag({
          orgId: orgItem.id,
          id: record.id
        }).then(() => {
          modal.success({
            title: '成功',
            content: '删除成功'
          })

          getTagListAction()
        }).catch(() => {
          modal.error({
            title: '错误',
          })
        })
      }
    })
  }

  const handleChangeTagStatus = (record) => {
    updateTag({
      ...record,
      status: record.status === 1 ? 0 : 1,
      orgId: orgItem.id,
    }).then((res) => {
      if (res.code === ResponseCode.success) {
        notification.success({
          message: '操作成功',
          description: '切换标签状态成功'
        })
        insertSuccess()
      }
    }).catch(err => {
      console.error(err)
      Modal.error({
        title: '错误',
        content: '网络错误，新增公告失败'
      })
    }).finally(() => {
      setLoading(false)
    })
  }

  const paginationChange = (num, size) => {
    setPageNum(num)
    setPageSize(size)
  }

  const getTagListAction = () => {
    setLoading(true)

    getTagList({ orgId: orgItem.id }).then(res => {
      if (res.code === ResponseCode.success) {
        setTableData(res.data)
      } else {
        modal.error({
          title: '错误',
          content: res.msg
        })
      }
    }).catch(err => {
      console.error(err)
      modal.error({
        title: '错误',
        content: '网络错误，查询标签列表失败'
      })
    }).finally(() => {
      setLoading(false)
    })
  }

  const showCreateTagModal = (type, item) => {
    createTagModalRef.current.showModal(type, item)
  }

  const insertSuccess = () => {
    getTagListAction()
  }

  useEffect(() => {
    if (orgItem.id && modalVisible) {
      getTagListAction()
    }
  }, [orgItem, modalVisible, pageNum, pageSize])

  return (
    <div>
      <Space className={ 'd-flex justify-content-end' }>
        <Button
          type={ 'primary' }
          onClick={ showCreateTagModal.bind(this, 'create') }
        >新增标签</Button>
      </Space>
      <Table
        columns={ columns }
        loading={ loading }
        dataSource={ tableData }
        rowKey={ (record) => record.id }
        pagination={ {
          showTotal: (total) => {
            return `共 ${ total } 条`
          },
          size: 'default',
          showSizeChanger: true,
          total: tableData.length,
          pageSize: pageSize,
          current: pageNum,
          onChange: paginationChange
        } }
      ></Table>

      <CreateTagItemModal
        ref={ createTagModalRef }
        orgItem={ orgItem }
        insertSuccess={ insertSuccess }
      ></CreateTagItemModal>
    </div>
  )
}

export default ConfigTagManagement
